"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcMeterSelector = class UcMeterSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    path;
    onPath(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("path");
    }
    parameters;
    onParameters(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parameters");
    }
    required;
    onRequired(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("required");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    autofocus;
    onAutofocus(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("autofocus");
    }
    clearable;
    onClearable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("clearable");
    }
    ux;
    b_7315092382398562_dataSource;
    async $$load_b_7315092382398562_dataSource() {
        return {
            name: "suggest_meter",
            parameters: this.parameters,
        };
    }
    dataMembers = ['ux', 'b_7315092382398562_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_7315092382398562_dataSource: null,
            },
        };
    }
    async act_7315092382398562_script_7614_getActionArgs_value($event) {
        this.$emit('optionSelected', $event.data.option);
    }
    async act_7315092382398562_script_7614_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_7614_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_optionSelected(event, scope) {
        return await this.actions.evh_7315092382398562_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_7614 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_7614_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_optionSelected_7613 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_7614,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_7315092382398562_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_optionSelected_7613],
        });
        return {
            act_7315092382398562_script_7614,
            evh_7315092382398562_optionSelected_7613,
            evh_7315092382398562_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcMeterSelector.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcMeterSelector.prototype, "path", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('path'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onPath", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcMeterSelector.prototype, "parameters", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parameters'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onParameters", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcMeterSelector.prototype, "required", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('required'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onRequired", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcMeterSelector.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onReadonly", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcMeterSelector.prototype, "autofocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('autofocus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onAutofocus", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcMeterSelector.prototype, "clearable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('clearable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterSelector.prototype, "onClearable", null);
UcMeterSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcMeterSelector);
exports.default = UcMeterSelector;
vue_property_decorator_1.Vue.component("UcMeterSelector", UcMeterSelector);
